export default {
  sm: `
    전 세계와 연결된 데이터센터 각의
    도전은 계속됩니다.
  `,
  md: `
    전 세계와 연결된 데이터센터 각의
    도전은 계속됩니다.
  `,
};
